"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoadingContent_1 = require("./LoadingContent");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return LoadingContent_1.default; } });
